import { render, staticRenderFns } from "./name-editor.vue?vue&type=template&id=1e68bfbd&scoped=true"
import script from "./name-editor.vue?vue&type=script&lang=js"
export * from "./name-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e68bfbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e68bfbd')) {
      api.createRecord('1e68bfbd', component.options)
    } else {
      api.reload('1e68bfbd', component.options)
    }
    module.hot.accept("./name-editor.vue?vue&type=template&id=1e68bfbd&scoped=true", function () {
      api.rerender('1e68bfbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/name-editor.vue"
export default component.exports